export enum TEXT_QUESTION_TYPE {
  AUDIO_QUESTION = 'audioQuestion',
  BLANKS_QUESTION = 'blanksQuestion',
  CIRCLE_QUESTION = 'circleQuestion',
  FLASH_QUESTION = 'flashQuestion',
  MULTIPLE_CHOICE_QUESTION = 'multipleChoiceQuestion',
  PLAIN_QUESTION = 'plainQuestion',
}
